"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _urls = require("../../../../utils/urls");

var I18N_PATH = 'appMarketplace.detail.overview.sidebar.resources';

var Link = function Link(props) {
  return _react.default.createElement(_UILink.default, (0, _extends2.default)({}, props, {
    external: true,
    iconProps: {
      className: 'hidden'
    }
  }));
};

var Resources = function Resources(_ref) {
  var casesUrl = _ref.casesUrl,
      forumUrl = _ref.forumUrl,
      onTrackInteraction = _ref.onTrackInteraction,
      setupUrl = _ref.setupUrl,
      supportUrl = _ref.supportUrl;
  var trackInteraction = (0, _react.useCallback)(function (action) {
    return onTrackInteraction(action, 'resources');
  }, [onTrackInteraction]);
  return _react.default.createElement(_UIList.default, null, _react.default.createElement(Link, {
    href: (0, _urls.getFormattedUrl)(setupUrl),
    onClick: function onClick() {
      return trackInteraction('click setup guide link');
    }
  }, _react.default.createElement(_UIIcon.default, {
    name: "lesson"
  }), _react.default.createElement(_FormattedMessage.default, {
    message: I18N_PATH + ".setupGuideLinkText"
  })), supportUrl && _react.default.createElement(Link, {
    href: (0, _urls.getFormattedUrl)(supportUrl),
    onClick: function onClick() {
      return trackInteraction('click support website link');
    }
  }, _react.default.createElement(_UIIcon.default, {
    name: "website"
  }), _react.default.createElement(_FormattedMessage.default, {
    message: I18N_PATH + ".supportWebsiteLinkText"
  })), forumUrl && _react.default.createElement(Link, {
    href: (0, _urls.getFormattedUrl)(forumUrl),
    onClick: function onClick() {
      return trackInteraction('click community link');
    }
  }, _react.default.createElement(_UIIcon.default, {
    name: "lists"
  }), _react.default.createElement(_FormattedMessage.default, {
    message: I18N_PATH + ".communityLinkText"
  })), casesUrl && _react.default.createElement(Link, {
    href: (0, _urls.getFormattedUrl)(casesUrl),
    onClick: function onClick() {
      return trackInteraction('click case study link');
    }
  }, _react.default.createElement(_UIIcon.default, {
    name: "book"
  }), _react.default.createElement(_FormattedMessage.default, {
    message: I18N_PATH + ".caseStudyLinkText"
  })));
};

Resources.propTypes = {
  casesUrl: _propTypes.default.string,
  forumUrl: _propTypes.default.string,
  onTrackInteraction: _propTypes.default.func.isRequired,
  setupUrl: _propTypes.default.string.isRequired,
  supportUrl: _propTypes.default.string
};
var _default = Resources;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/overview/sidebar/Resources.js
// module id = 825
// module chunks = 209 210 211 212